import { InjectionToken } from '@angular/core';

export const FIREFLY_SUGGESTER = new InjectionToken<string>('FireflySuggester');
